<div class="mat-typography mat-body mat-app-background inline-block">
  <div class="logout-label" (click)="trigger()">
      <slot name="subText_one">
        Logout
      </slot>
    </div>
</div>
